var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgItalyHand = function SvgItalyHand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#282838"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.59 35.248c.025.025 14.351 2.632 19.71-2.008l.731-.623c5.286-4.59 11.093-9.613 10.977-14.086-.119-4.473-2.171-8.992-2.479-9.686l-8.215-7.648c-.472.311-1.297 1.123-.59 2.918l-.92.383C18.483 1.148 21.196.12 21.22.12l.283-.12 8.757 8.178.119.145c0 .025 2.478 5.118 2.619 10.165.143 4.973-5.855 10.164-11.33 14.9l-.71.623C15.222 38.984.445 36.259.4 36.259l.192-1.01Z",
    stroke: "#282838",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.07 23.676c.024 0 8.331.694 10.456-.262l.402.91C8.568 25.398.024 24.679 0 24.679l.07-1.003Z",
    stroke: "#282838",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.795 25.324c0-.024 1.227-3.276 1.227-5.355 0-2.345 4.46-7.916 4.46-7.94l.07-.072s2.172-1.888 1.182-7.484l-.07-.383.353-.166s2.975-1.41 4.65 1.196c.472.695.804 1.41 1.038 2.176.19.502.59.765.59.765l.214.12.024.216c.402 2.104 2.336 3.347 2.336 3.347l.353.216-.164.407c-.756 1.697-.025 3.036-.025 3.036l.19.382-3 2.487-.259.12s-2.786.407-1.534-4.424c.52-2.008.709-3.563.614-4.877-.118-1.293-.52-2.367-1.202-3.421-.92-1.41-2.384-1.173-3.07-.957.85 5.43-1.227 7.676-1.534 7.963-.283.382-4.202 5.38-4.202 7.293 0 2.248-1.297 5.691-1.297 5.691l-.944-.336Zm13.266-15.28c-.024 1.197-.237 2.558-.66 4.162-.71 2.749.024 3.134.331 3.18l2.266-1.888c-.213-.573-.472-1.77 0-3.156-.475-.385-1.346-1.175-1.937-2.298Z",
    stroke: "#282838",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.465 9.184s2.031.382 2.031-.145c0-.98 0-3.517-2.076-3.252l-.12-1.005c3.189-.407 3.189 2.965 3.189 4.257 0 1.77-3.21 1.123-3.21 1.123l.186-.978Z",
    stroke: "#282838",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.258 1.364s-.944.885-.213 1.388c.52.358.992.549 1.392.623.377.07.636.024.755-.071l.709.718c-.332.312-.92.479-1.629.358-.52-.095-1.133-.336-1.793-.79-1.748-1.218.094-2.964.094-2.964l.685.738Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v37H0z"
  })))));
};
export default SvgItalyHand;